import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AccountRole, AllAccountRoles } from 'models/account.model';

import { AppAuthGuard } from './app.authguard';
import { DefaultRouteGuard } from './default-route-guard';
import { EmptyComponent } from './utils/empty.component';
import { SystemAdminDashboardComponent } from './system-admin-dashboard/system-admin-dashboard/system-admin-dashboard.component';
import { AccountTypeGuard } from './app.account-type-guard';
import { ForbiddenComponent } from 'shared/forbidden/forbidden.component';

const routes: Routes = [
  { path: '',
    canActivate: [DefaultRouteGuard],
    component: EmptyComponent
  },
  { path: 'hilfe', redirectTo: '/', pathMatch: 'full' },
  {
    path: 'angebote',
    loadChildren: (): any => import('./dashboard/dashboard.module')
      .then((m) => m.DashboardModule),
    canActivate: [AppAuthGuard]
  },
  {
    path: 'system-admin-dashboard',
    component: SystemAdminDashboardComponent,
    canActivate: [AccountTypeGuard],
    data: { requiredAccountType: 'SYSTEM_ADMIN' }
  },
  {
    path: 'einstellungen',
    loadChildren: (): any => import('./settings/settings.module')
      .then((m) => m.SettingsModule),
    canActivate: [AppAuthGuard],
    data: {
      restrictedRoles: {
        dealer: [AccountRole.USER],
        manufacturer: [AccountRole.USER]
      }
    }
  },
  {
    path: 'product-configuration',
    loadChildren: (): any => import('./product-configuration/product-configuration.module')
      .then((m) => m.ProductConfigurationModule),
    canActivate: [AppAuthGuard]
  },
  {
    path: 'product-selector',
    loadChildren: (): any => import('./product-selector/product-selector.module')
      .then((m) => m.ProductSelectorModule),
    canActivate: [AppAuthGuard]
  },
  {
    path: 'offer',
    loadChildren: (): any => import('./offer/offer.module')
      .then((m) => m.OfferModule),
    canActivate: [AppAuthGuard]
  },
  {
    path: 'anfragen',
    loadChildren: (): any => import('./dashboard-rfps/dashboard-rfps.module')
      .then((m) => m.DashboardRfpsModule),
    canActivate: [AppAuthGuard],
    data: {
      restrictedRoles: {
        dealer: AllAccountRoles
      }
    }
  },
  {
    path: 'ui-test',
    loadChildren: (): any => import('./ui-test/ui-test.module')
      .then((m) => m.UiTestModule),
    canActivate: [AppAuthGuard]
  },
  {
    path: 'stammdaten',
    loadChildren: (): any => import('./core-data/core-data.module')
      .then((m) => m.CoreDataModule),
    canActivate: [AppAuthGuard]
  },
  {
    path: 'mein-profil',
    loadChildren: (): any => import('./account-profile/account-profile.module')
      .then((m) => m.AccountProfileModule),
    canActivate: [AppAuthGuard]
  },
  { path: 'forbidden', component: ForbiddenComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { anchorScrolling: 'enabled' })],
  exports: [RouterModule],
  providers: [AppAuthGuard]
})

export class AppRoutingModule { }
